const { populate } = require('@/functions/objects');
const {
    toInt,
    toString,
} = require('@/functions/transform');

/**
 * A document number is an additional number an order has been assigned, for various purposes.
 * Examples include:
 * - A sequence of sequential numbers for every order made in a year, for Greek tax purposes (GREEK_TXN_NUMBER_PROPOINT)
 * - A daily sequence of collection numbers for F&B orders (ORDER_COLLECTION_NUMBER)
 *
 * An order can have several of these, one for each sequence it has been assigned a number from.
 * It may have multiple of the same type from different sequences.
 */
class DocumentNumber {
    constructor(data = {}) {
        /**
         * @see {import('@/lib/Orders/DocumentNumbers/DocumentTypeEnum')}
         *
         * @type {DocumentTypeEnumValue}
         */
        this.documentType = undefined;

        /**
         * @type {number}
         */
        this.documentNumberSequenceID = undefined;

        /**
         * @type {string}
         */
        this.documentNumberSequencePrefix = undefined;

        /**
         * The number as claimed from the sequence, without any prefix or padding.
         *
         * @type {number}
         */
        this.number = undefined;

        /**
         * The number as it should be presented, including any display prefix and padding.
         *
         * @type {string}
         */
        this.displayNumber = undefined;

        populate(this, data);
    }

    getHydrationMap() {
        return {
            documentType: toString,
            documentNumberSequenceID: toInt,
            documentNumberSequencePrefix: toString,
            number: toInt,
            displayNumber: toString,
        };
    }
}

module.exports = DocumentNumber;
